var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWritingSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 74,
    viewBox: "0 0 78 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 57.8085C20.5822 51.7234 26 45.6383 26 39.5532C26 30.4255 22.75 30.4255 19.5 30.4255C16.25 30.4255 12.896 33.7267 13 39.5532C13.1105 45.7843 18.3885 48.3066 21.125 51.7234C26 57.8085 29.25 59.3298 32.5 54.766C34.6677 51.7234 36.2927 49.189 37.375 47.1596C40.625 54.2579 44.9572 57.8085 50.375 57.8085H58.5",
    stroke: "#0067B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51.7234V15.2128C65 11.8021 62.1433 9.12769 58.5 9.12769C54.8567 9.12769 52 11.8021 52 15.2128V51.7234L58.5 57.8085L65 51.7234Z",
    stroke: "#0067B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21.2979H65",
    stroke: "#0067B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingSign);
export default __webpack_public_path__ + "static/media/writing-sign.07300e24d4bf0434237570dc409afb54.svg";
export { ForwardRef as ReactComponent };